import { Facebook, Youtube } from "lucide-react";

export function TikTokIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M16.5 3c.3 2 1.6 3.6 3.5 4v2.5c-1.3 0-2.6-.4-3.7-1.1v6.7c0 3.2-2.6 5.9-5.9 5.9S4.5 18.4 4.5 15.2s2.6-5.9 5.9-5.9c.3 0 .6 0 .9.1v2.7c-.3-.1-.6-.2-.9-.2-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2 3.2-1.4 3.2-3.2V3h2.9z" />
    </svg>
  );
}

export const PLATFORMS = {
  facebook: { label: "Facebook", icon: Facebook },
  tiktok: { label: "TikTok", icon: TikTokIcon },
  youtube: { label: "YouTube", icon: Youtube },
};
